/* eslint-disable */
import ChallengeListBody from "components/ChallengeComponents/ChallengeListComponents/ChallengeListBody/ChallengeListBody";
import Header from "components/Common/Header/Header";
import React, { useEffect } from "react";

const ChallengeList = () => {
  useEffect(() => {
    document.title = "Challenges";
  }, []);
  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="challenges" />

      {/* ---- body section ---- */}
      <ChallengeListBody />
    </main>
  );
};

export default ChallengeList;
